export default __webpack_public_path__ + "static/media/schedule.9d98b54c.svg";